//sliderTH version 2.0
import {visibleInElement, fullyVisibleInElement, getCoords, lazyload} from "../util/lazyload";

function getWindowSuffix($) {
    let width = $(window).width();
    let ret = "";
    if (width < 900) {
        ret = "-sm"
    }
    return ret;
}

export default {
    init($body) {
        let $slideContainer = $body.find(".slide-container");


        if ($slideContainer.length) {
            $slideContainer.each(function () {
                let $window = $(this).find(".slide-window.checkable:not(.checked)");
                if ($window.length) {
                    let $first = $window.find(".slide-element:first-of-type");
                    let nbToScroll = $(this).data("nb-scroll") * 1 || 1;
                    let direction = "horizontal";
                    if ($(this).find(".scroll-bottom")) {
                        direction = "vertical";
                        if ($(this).find(".scroll-left")) {
                            direction = "all";
                        }
                    }
                    switch (direction) {
                        case"horizontal": {
                            $window.width($first.width() * nbToScroll);
                            $window.height($first.height());
                            break;
                        }
                        case"vertical": {
                            $window.width($first.width());
                            $window.height($first.height() * nbToScroll);
                            break;
                        }
                        case"all": {
                            $window.width($first.width() * nbToScroll);
                            $window.height($first.height() * nbToScroll);
                            break;
                        }
                    }
                    $window.addClass("checked");
                }
            });


            $slideContainer.on("click", ".scroll", function () {
                let direction = "down";
                if ($(this).hasClass("scroll-up")) {
                    direction = 'up';
                }
                if ($(this).hasClass("scroll-left")) {
                    direction = 'left';
                }
                if ($(this).hasClass("scroll-right")) {
                    direction = 'right';
                }


                let $parent = $(this).parents(".slide-container");
                let nbToScroll = $parent.data("nb-scroll" + getWindowSuffix($)) * 1 || 1;
                let $element = $parent.find(".slider");
                let $last = $element.find(".slide-element:last-of-type");
                let width = $parent.data("width") * 1 || $last.width();


                let $window = $parent.find(".slide-window");
                let unite = width * nbToScroll;

                // console.log("scroll", direction, /*$window,*/ width);

                if ($element.length && $window.length) {


                    let position = $element.position();
                    let top = position.top * 1;
                    let left = position.left * 1;


                    let visible = visibleInElement($last, getCoords($window));
                    if ($element.hasClass("full")) {
                        visible = fullyVisibleInElement($last, getCoords($window));
                    }
                    let lastPos, tocheck;

                    switch (direction) {
                        case 'down':
                        case 'up': {
                            lastPos = $last.offset().top + $last.height();
                            tocheck = $window.offset().top;
                            break;
                        }
                        case 'left':
                        case 'right': {
                            lastPos = $last.offset().left + $last.width();
                            tocheck = $window.offset().left;
                            break;
                        }
                        default: {
                            lastPos = 1;
                            tocheck = 0;
                            break;
                        }
                    }
                    if (!visible) {
                        visible = lastPos < tocheck;
                    }


                    // console.log("scroll", direction, $element, visible, unite);

                    switch (direction) {
                        case 'up': {
                            top += unite;
                            break;
                        }
                        case 'down': {
                            top -= unite;
                            break;
                        }
                        case 'left': {
                            left += unite;
                            break;
                        }
                        case 'right': {
                            left -= unite;
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    if (top > 0 || visible) {
                        top = 0;
                        $parent.find(".scroll-up").hide();
                    } else {
                        $parent.find(".scroll-up").show();
                    }
                    if (left > 0 || visible) {
                        left = 0;
                        $parent.find(".scroll-left").hide();
                    } else {
                        $parent.find(".scroll-left").show();
                    }
                    $element.css({"top": top, "left": left});


                }
                setTimeout(function () {
                    lazyload();
                }, 302);

            });
        }


    },
}


// WEBPACK FOOTER //
// ./scripts/util/sliderTh.js